<!--
 * @Author: 
 * @LastEditTime: 2024-07-09 15:57:45
 * @Description: 
-->
<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-8px">
    <div class="h-33/100">
      <div class="flex justify-between items-center">
        <CategoryTitle title="作业数量统计"></CategoryTitle>
        <TableButtonGroup v-model="activeTab" :list="tabList" @btn-click="tabClick" />
      </div>
      <div class="flex flex-wrap justify-between h-44px mt-8px text-center" @click="checkDetail">
        <div
          v-for="(item, index) in workVolumeStatistics"
          :key="index"
          class="flex flex-col justify-around pt-2px w-31/100 text-hex-fff cursor-pointer"
          :style="`background: url(${item.bgImg}) no-repeat center/100% 100%`"
        >
          <div class="text-14px text-hex-ffffff opacity-80">{{ item.name }}</div>
          <div class="text-20px font-bold">{{ item.count || 0}}</div>
        </div>
      </div>
      <div class="mt-6px h-[calc(100%-80px)]">
        <v-chart v-loading="chartLoading" :options="option" autoresize class="w-full h-full"></v-chart>
      </div>
    </div>
    <div class="w-full h-34/100">
      <div class="flex justify-between items-center">
        <CategoryTitle title="中高风险作业管控"></CategoryTitle>
        <TableButtonGroup v-model="riskActiveTab" :list="tabList" @btn-click="riskTabClick" />
      </div>
      <div class="flex flex-wrap items-center mt-5px h-[calc(100%-20px)]">
        <div
          v-for="(item, index) in riskWorkControlList"
          :key="index"
          class="flex flex-col justify-around items-center w-25/100 h-48% text-hex-fff text-center cursor-pointer"
          @click="checkDetail(item)"
        >
          <img :src="riskImgMaps[item.prTicketType]" class="h-50px" alt="" />
          <div class="risk-work-num-font text-18px font-400 text-hex-45f2eb">{{ item.total }}</div>
          <div class="text-12px font-400 opacity-70 mt-4px">{{ item.prTicketTypeName }}</div>
        </div>
      </div>
    </div>
    <div class="w-full h-33/100 mt-8px">
      <CategoryTitle title="低风险作业"></CategoryTitle>
      <div class="flex flex-wrap justify-between low-list h-[calc(100%-127px)]">
        <div
          v-for="(item, index) in lowRiskWorList"
          :key="index"
          class="flex flex-col justify-around w-30/100 text-hex-fff h-48% text-center mt-6px cursor-pointer"
          :style="`background: url(${riskImgMaps[item.prTicketType]}) no-repeat center/100% 100%`"
          @click="checkDetail(item)"
        >
          <div class="text-14px font-bold">{{ item.total }}</div>
          <div class="text-12px font-400 opacity-80">{{ item.prTicketTypeName }}</div>
        </div>
      </div>
      <div class="w-full mt-5px h-100px">
        <div class="flex justify-between items-center mb-5px">
          <CategoryTitle title="今日报警轮播"></CategoryTitle>
          <div class="flex items-center text-hex-fbff11 cursor-pointer">
            <span class="text-14px" @click="checkAllAlarm">全部报警</span>
            <span
              class="ml-5px text-white text-16px opacity-60"
            >
              <i class="el-icon-d-arrow-right"></i>
            </span>
          </div>
        </div>
        <InfiniteScroll
          class="h-82px overflow-hidden"
          direction="Y"
          :limit="2"
          :num="alarmingData.length"
          :speed="0.5"
          ref="infiniteScrollRef"
          @reset="resetScrollHeight"
          v-if="alarmingData.length"
        >
          <div class="w-full">
            <div
              v-for="(i, index) in alarmingData"
              :key="index"
              class="flex w-full work-waring-bg h-36px text-hex-fff mt-5px px-6px"
            >
              <div class="w-1/7 flex flex-col py-5px justify-center">
                <div class="work-waring-icon w-32px h-34px"></div>
              </div>
              <div class="w-6/7 flex justify-between items-center text-14px font-400">
                <div class="w-1/2">{{ i.name }}</div>
                <div class="w-1/2">{{ i.eventStartTime }}</div>
              </div>
            </div>
          </div>
        </InfiniteScroll>
        <div v-else class="h-[calc(100%-18px)] flex flex-col justify-center items-center text-white">
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    <WorkAlarmList
      v-if="isShowDialog"
      :isShowDialog.sync="isShowDialog"
    ></WorkAlarmList>
  </div>
</template>

<script>
import axios from 'axios'
import { isEmpty, map, omit, omitBy, isNil, eq, get, uniqBy, find, compact } from 'lodash'
import dayjs from 'dayjs'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import {
  StandardAlarmSettingApi,
  StandardAlarmRecordApi,
} from '@wiz-api/personnel-position'
import { WorkTicketsApi } from '@wiz-api/huizhou2-business'
import InfiniteScroll from '../InspectionAPicture/components/InfiniteScroll'

import { token, riskImgMaps } from './constant'

const WorkAlarmList = () => {
  return import('./WorkAlarmList')
}

const alarmRecordApi = new StandardAlarmRecordApi()
const workTicketsApi = new WorkTicketsApi()

const baseUrl = Wiz.GetModuleServer()

export default {
  components: {
    CategoryTitle,
    TableButtonGroup,
    InfiniteScroll,
    WorkAlarmList
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeTab: '日',
      riskActiveTab: '日',
      tabList: ['日', '月'],
      chartLoading: false,
      isShowDialog: false,
      riskImgMaps,
      timer: null,
      workVolumeStatistics: [
        {
          name: '操作票数量',
          count: 0,
          bgImg: require('../../../assets/images/workAPicture/operate-num-bg.png')
        },
        {
          name: '工作票数量',
          count: 0,
          bgImg: require('../../../assets/images/workAPicture/work-num-bg.png')
        },
        {
          name: '外委作业数量',
          count: 0,
          bgImg: require('../../../assets/images/workAPicture/outsourced-num-bg.png')
        }
      ],
      riskWorkControlList: [
        {
          prTicketTypeName: '一级动火作业',
          prTicketType: 'DONGHUO_LEVEL_ONE',
          total: 0,
        },
        {
          prTicketTypeName: '二级动火作业',
          prTicketType: 'DONGHUO_LEVEL_TWO',
          total: 0,
        },
        {
          prTicketTypeName: '一级有限空间',
          prTicketType: 'Limited_Space_One',
          total: 0,
        },
        {
          prTicketTypeName: '二级有限空间',
          prTicketType: 'Limited_Space_Two',
          total: 0,
        },
        {
          prTicketTypeName: '一级吊装',
          prTicketType: 'Hoisting_One',
          total: 0,
        },
        {
          prTicketTypeName: '二级吊装',
          prTicketType: 'Hoisting_Two',
          total: 0,
        },
        {
          prTicketTypeName: '三级吊装',
          prTicketType: 'Hoisting_Three',
          total: 0,
        },
        {
          prTicketTypeName: '高处作业',
          prTicketType: 'High_Altitude_Operations',
          total: 0,
        },
      ],
      lowRiskWorList: [
        {
          prTicketTypeName: '电气第一种工作票',
          prTicketType: 'ELECTRICAL_FIRST',
          total: 0,
        },
        {
          prTicketTypeName: '电气第二种工作票',
          prTicketType: 'ELECTRICAL_SECOND',
          total: 0,
        },
        {
          prTicketTypeName: '热控工作票',
          prTicketType: 'THERMAL_CONTROL',
          total: 0,
        },
        {
          prTicketTypeName: '机械工作票',
          prTicketType: 'MECHANICAL',
          total: 0,
        },
        {
          prTicketTypeName: '风机工作票',
          prTicketType: 'WIND_TURBINE',
          total: 0,
        },
      ],
      alarmingData: [],
      option: {
        title: {
          text: '',
          left: '14%',
          top: '40%',
          textStyle: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.85)',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
          right: 0,
          icon: 'circle',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: 30,
          right: 10,
          bottom: 30,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: {
              color: '#fff',
            },
            axisLine: {
              lineStyle: {
                color: '#6f717a',
              },
            },
            axisTick: {
              lineStyle: {
                color: '#6f717a',
              },
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#fff',
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          }
        ],
        series: [
          {
            name: '工作票',
            type: 'bar',
            data: [],
            label: {
              show: false,
            },
            itemStyle: {
              color: '#68bbc4',
            },
            barWidth: '20%',
          },
          {
            name: '操作票',
            type: 'bar',
            data: [],
            label: {
              show: false,
            },
            itemStyle: {
              color: '#5087ec',
            },
            barWidth: '20%',
          },
        ],
      },
      relevanceList: [],
      standardFenceIds: [],
      standardFenceIdsStr: '',
      alarmingPage: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getWorkTicketNum()
    this.getOutsourceTicketNum()
    this.getWorkTicketStatistics()
    this.getWorkTicketRiskCount()
    this.getAlarmingList()
    this.startTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    resetScrollHeight() {
      this.$refs.infiniteScrollRef.height = 0
    },
    async checkDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'WorkList', origin: 'WorkAPicture', name: '作业列表' },
        type: 'mainComponent',
        props: {
          ...row,
        },
      })
      const event = new CustomEvent('setLabelChecked', {
        detail: {
          code: 'RiskAssignment',
          checked: true,
        },
      })
      window.dispatchEvent(event)
    },
    checkAllAlarm() {
      this.isShowDialog = true
    },
    // 日月切换
    tabClick(val) {
      this.activeTab = val
      this.getWorkTicketNum()
      this.getOutsourceTicketNum()
    },
    riskTabClick(val) {
      this.riskActiveTab = val
      this.getWorkTicketRiskCount()
    },
    // 工作票数量
    getWorkTicketNum() {
      const params = {
        beginTime: dayjs().startOf('day').subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.activeTab === '日') {
        params.beginTime = ''
        params.endTime = ''
        params.status = 'executing'
      }
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/hz/work_tickets_count/V1.0?token=${token}`,
        // url: `${baseUrl}/openapi/hz/work_tickets_count/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        params
      }).then((res) => {
        this.workVolumeStatistics[1].count = res.data?.data?.[0].count || 0
      })
    },
    // 外委工作票数量
    getOutsourceTicketNum() {
      const params = {
        external: 1,
        beginTime: dayjs().startOf('day').subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.activeTab === '日') {
        params.beginTime = ''
        params.endTime = ''
        params.status = 'executing'
      }
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/hz/work_tickets_count/V1.0?token=${token}`,
        // url: `${baseUrl}/openapi/hz/work_tickets_count/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        params
      }).then((res) => {
        this.workVolumeStatistics[2].count = res.data?.data?.[0].count || 0
      })
    },
    // 获取工作票统计
    getWorkTicketStatistics() {
      const params = {
        beginTime: dayjs().subtract(7, 'day').startOf(this.activeTab === '月' ? 'month' : 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf(this.activeTab === '月' ? 'month' : 'day').format('YYYY-MM-DD HH:mm:ss')
      }
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/hz/work_tickets_day_count/V1.0?token=${token}`,
        // url: `${baseUrl}/openapi/hz/work_tickets_day_count/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        params
      }).then((res) => {
        this.option.series[0].data = (res.data?.data ?? []).map(item => item.total)
        this.option.xAxis[0].data = (res.data?.data ?? []).map(item => dayjs(item.time).format('MM-DD'))
      })
    },
    // 获取低中高风险统计数据
    async getWorkTicketRiskCount() {
      const params = {
        beginTime: dayjs().startOf('day').subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        riskWorkticketLevelStr: '低,中,高'
      }
      if (this.riskActiveTab === '日') {
        params.beginTime = ''
        params.endTime = ''
        params.status = 'executing'
      }
      const [err, res] = await workTicketsApi.getWorkTicketTypeCount(params)
      if (!err && res) {
        this.riskWorkControlList = map(this.riskWorkControlList, (item) => {
          const obj = find(res.items, { prTicketType: item.prTicketType })
          if (obj?.riskWorkticketLevel === '中' || obj?.riskWorkticketLevel === '高') {
            return {
              ...item,
              total: obj.total
            }
          }
          return {
            ...item,
            total: 0
          }
        })
        this.lowRiskWorList = map(this.lowRiskWorList, (item) => {
          const obj = find(res.items, { prTicketType: item.prTicketType })
          if (obj?.riskWorkticketLevel === '低') {
            return {
              ...item,
              total: obj.total
            }
          }
          return {
            ...item,
            total: 0
          }
        })
      }
    },
    // 获取关联列表
    async getRelevanceList() {
      const [err, res] = await workTicketsApi.getWorkTicketStandardFenceRelevanceByList({
        body: {
          workTicketIds: [],
          standardFenceIds: [],
        }
      })
      if (!err && res) {
        this.relevanceList = res.items
        // 关联作业类型下拉数据源
        this.standardFenceIds = compact(map(this.relevanceList, 'standardFenceId'))
        this.standardFenceIdsStr = this.standardFenceIds.join(',')
      }
    },
    // 获取今日报警中数据
    async getAlarmingList() {
      await this.getRelevanceList()
      if (!this.standardFenceIdsStr) return
      const [err, res] = await alarmRecordApi.getList({
        alarmType: this.alarmType,
        dataSource: this.source,
        standardFenceIdsStr: this.standardFenceIdsStr || '',
        startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        alarmRemoveType: 0,
        maxResultCount: this.alarmingPage.pageSize,
        skipCount: (this.alarmingPage.pageNo - 1) * this.alarmingPage.pageSize,
      })
      if (!err && res) {
        this.alarmingData = map(res.items, (item) => {
          const obj = find(this.relevanceList, { standardFenceId: item.standardFenceId })
          if (obj) {
            item.ticketNo = obj.ticketNo
            item.ticketTypeName = obj.ticketTypeName
          }
          return {
            ...item,
            eventStartTime: moment(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss'),
            name: item.personNames + item.alarmTypeName
          }
        })
        this.alarmingPage.total = res.totalCount
      }
    },
    // 启动定时器5分钟更新一次数据
    startTimer() {
      this.stopTimer()
      this.timer = setInterval(() => {
        this.getAlarmingList()
      }, 5 * 50 * 1000)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.operate-bg {
  background: url('../../../assets/images/workAPicture/operate-num-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.work-num-bg {
  background: url('../../../assets/images/workAPicture/work-num-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.outsourced-num-bg {
  background: url('../../../assets/images/workAPicture/outsourced-num-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.low-list:after {
  content:'';
  width: 30%;
}
.risk-work-num-font {
  font-family: 'YouSheBiaoTiHei';
}
.work-waring-bg {
  background: url('../../../assets/images/workAPicture/work_warning_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.work-waring-icon {
  background: url('../../../assets/images/workAPicture/work_warning.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
